module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_4.76d51db5.png";